export default "__VITE_ASSET__DRNGsD1l__"